// extracted by mini-css-extract-plugin
export default {"errorHint":"ErrorHint_errorHint__N5YrU","text":"ErrorHint_text__x6KFD","button":"ErrorHint_button__Wu6UP"};